export default {
  backEmployees: 'Employees',
  backDashboard: 'Dashboard',
  employee: 'Employee',
  inactive: 'Inactive',
  message: 'Message',
  onSinceStatus: '<b>On site</b> <m>at</m> <site>site</site> <m>since</m> <time>{time}</time>',
  offSiteStatus: '<b>Off site</b> <m>· last seen at</m> <site>site</site> <time>{time}</time>',
  noAttendanceYet: 'No attendance recorded yet',
  tabOverview: 'Overview',
  tabEmployment: 'Employment',
  tabPersonal: 'Personal',
  tabEmergency: 'Emergency contacts',
  tabLeave: 'Leave',
  tabPerformance: 'Performance',
  tabPay: 'Pay',
  tabAttendance: 'Attendance',
  tabAreas: 'Site areas',
  tabFiles: 'Files',
  tabHistory: 'History',
  thisWeek: 'This week',
  asOf: 'as of {time} · {timezone}',
  thisMonth: 'This month',
  acrossVisibleSites: 'Across all visible sites',
  device: 'Device',
  noneDevice: 'None',
  notPaired: 'Not paired',
  permissions: 'Permissions',
  reportedAgo: 'Reported {ago}',
  neverReported: 'Never reported',
  totalsApproximate: 'Totals are approximate (first 2000 sessions).',
  history: 'History',
  inRange: '{count} in range',
  exportCsv: 'Export CSV',
  noAttendanceTitle: 'No attendance in this range',
  noAttendanceMessage: 'Try a wider date range.',
  colSite: 'Site',
  colEntered: 'Entered',
  colExited: 'Exited',
  colDuration: 'Duration',
  colLocation: 'Location',
  stillOnSite: 'Still on site',
  active: 'Active',
  closed: 'Closed',
  viewGpsLocation: 'View GPS location',
  gpsFixClockIn: 'Clock-in GPS fix, {time}',
  gpsFixClockInOut: 'Clock-in and clock-out GPS fix, {time}',
  clockIn: 'Clock-in',
  clockOut: 'Clock-out',
  permissionCheckRequested: "Asked this phone to re-check its permissions. It'll report back shortly.",
  requesting: 'Requesting…',
  requestPermissionCheck: 'Request permission check',
  permissionsReportedAutomatically: 'Their phone reports permission changes about every {minutes} minutes, so this updates on its own.',
  accuracy: '±{meters}m accuracy',
  openInGoogleMaps: 'Open in Google Maps',
  csvEmployeeNumber: 'employeeNumber',
  csvEmployeeName: 'employeeName',
  csvSiteName: 'siteName',
  csvEnteredUtc: 'enteredAtUtc',
  csvEnteredLocal: 'enteredAtLocal',
  csvExitedUtc: 'exitedAtUtc',
  csvExitedLocal: 'exitedAtLocal',
  csvDurationMinutes: 'durationMinutes',
  csvStatus: 'status',
  csvFilePrefix: 'attendance',
}
